import {
  useMemo,
} from 'react';
import useUserInfo from 'pages/Dashboard/hooks/useUserInfo';
import {
  EMRAccess,
  getEMRAccess,
} from 'views/EMR/access';

export default function useEMRAccess(): EMRAccess {
  const userInfo = useUserInfo();

  return useMemo(() => getEMRAccess(userInfo), [userInfo]);
}
